import React from 'react';

// Types
import { SectionComponent } from '@codersclan/gatsby-theme-airfleet/src/@types';
import { Section } from '../../@codersclan/gatsby-theme-airfleet/@types/section';

// Components
import Breadcrumb, { BreadcrumbItem } from '../../components/breadcrumb';

interface BreadcrumbProps extends Section {
  breadcrumb: {
    showBreadcrumbTextTrueFalse: boolean;
  };
}

const breadcrumbItems: BreadcrumbItem[] = [];

if (typeof window !== 'undefined') {
  breadcrumbItems.push({
    label: window.document.title || '',
    uri: window.location.pathname || '',
  });
}

const BreadcrumbSection: SectionComponent<BreadcrumbProps> = React.memo(
  ({ breadcrumb }) => (
    <>
      <Breadcrumb
        items={breadcrumb.showBreadcrumbTextTrueFalse ? breadcrumbItems : []}
      />
    </>
  ),
);

export default BreadcrumbSection;
